import ShipmentStatus from './ShipmentStatus';
import ShipmentStatusIcon from './ShipmentStatusIcon';

export default ShipmentStatus;
export { ShipmentStatusIcon };